import React, { useState, useEffect, memo } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './index.scss';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // 节流处理滚动事件
    let scrollTimeout: ReturnType<typeof setTimeout>;
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setIsScrolled(window.scrollY > 50);
      }, 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    };
  }, []);

  return (
    <motion.nav 
      className={`navbar ${isScrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
    >
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/">
            <div className="logo">
              <span className="logo-icon">LZH</span>
              <span className="logo-text">学习08空间</span>
            </div>
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="navbar-menu">
          <ul className="menu-items">
            <motion.li 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link to="/">首页</Link>
            </motion.li>
            <motion.li 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link to="/articles">文章</Link>
            </motion.li>
            <motion.li 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link to="/projects">项目</Link>
            </motion.li>
            <motion.li 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link to="/about">关于</Link>
            </motion.li>
          </ul>
        </div>

        {/* Mobile Menu Button */}
        <div className="navbar-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <div className={`toggle-icon ${isMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Mobile Menu */}
        <motion.div 
          className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}
          initial={{ opacity: 0, height: 0 }}
          animate={{ 
            opacity: isMenuOpen ? 1 : 0, 
            height: isMenuOpen ? 'auto' : 0 
          }}
          transition={{ duration: 0.3 }}
        >
          <ul className="mobile-menu-items">
            <li>
              <Link to="/" onClick={() => setIsMenuOpen(false)}>首页</Link>
            </li>
            <li>
              <Link to="/articles" onClick={() => setIsMenuOpen(false)}>文章</Link>
            </li>
            <li>
              <Link to="/projects" onClick={() => setIsMenuOpen(false)}>项目</Link>
            </li>
            <li>
              <Link to="/about" onClick={() => setIsMenuOpen(false)}>关于</Link>
            </li>
          </ul>
        </motion.div>
      </div>
    </motion.nav>
  );
};

export default memo(Navbar);